var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout_body"}},[_c('v-toolbar',{staticClass:"noprint",staticStyle:{"align-items":"center","background-color":"#2e3444"},attrs:{"short":"","flat":""}},[_c('v-img',{attrs:{"src":require('../static/logo_horizontal.png'),"contain":"","max-height":"50","max-width":"250"}}),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }